import React from "react";
import { getDisabledStateFromLifecycleStatuses } from "../../utilities/lifecycleStatus";
import {
	IconArchive,
	IconArchiveOff,
	IconDownload,
	IconMailCode,
	IconTrashOff,
	IconTrashX,
} from "@tabler/icons-react";
import { makeAdminDetailsMenuItem } from "../Admin/AdminDetailsMenuItem";
const EmailContextMenu = ({
	email,
	permissions,
	callbacks,
	location,
	isLexworkplaceAdmin,
	tenantID,
}) => {
	const { id, notes, emailLifecycleStatus } = email.original;

	const emailLifecycleStatusObject = getDisabledStateFromLifecycleStatuses({
		emailLifecycleStatus,
	});

	const { matterOrFolderLifecycleStatusObject, archiveAccess } = permissions;

	const {
		onDownload,
		onEditNote,
		onDelete,
		onRestore,
		onArchive,
		onUnarchive,
	} = callbacks;

	const { matterID, apiBasepath, root } = location;

	const parentDisabled = matterOrFolderLifecycleStatusObject.disabled;
	const parentDisabledText = matterOrFolderLifecycleStatusObject.disabledText;

	const emailArchiveAccess = archiveAccess
		? emailLifecycleStatusObject.IN_ARCHIVE
			? archiveAccess.unarchive
			: archiveAccess.archive
		: null;

	const menuItems = [
		isLexworkplaceAdmin
			? makeAdminDetailsMenuItem(`/admin/tenant/${tenantID}/email/${id}`)
			: null,
		{
			text: "Download a Copy",
			onSelect: () => onDownload(id),
			iconComponent: (
				<IconDownload size={16} style={{ verticalAlign: "sub" }} />
			),
		},
		{
			text: notes ? "Edit Email Short Note" : "Add Email Short Note",
			disabled: parentDisabled || emailLifecycleStatusObject.disabled,
			disabledHoverText: parentDisabled
				? parentDisabledText
				: emailLifecycleStatusObject.disabled
					? emailLifecycleStatusObject.disabledText
					: "",
			onSelect: () => onEditNote(email),
			iconComponent: (
				<IconMailCode size={16} style={{ verticalAlign: "sub" }} />
			),
		},
		{ sectionHeader: true, text: "Archive + Trash" },
		onArchive || onUnarchive
			? emailLifecycleStatusObject.IN_ARCHIVE
				? {
						text: "Unarchive Email",
						disabled: parentDisabled || emailArchiveAccess.disabled,
						disabledHoverText: parentDisabled
							? parentDisabledText
							: emailArchiveAccess.disabled
								? emailArchiveAccess.disabledText
								: "",
						onSelect: () =>
							onUnarchive([id], matterID, apiBasepath, root),
						iconComponent: (
							<IconArchiveOff
								size={16}
								style={{ verticalAlign: "sub" }}
							/>
						),
					}
				: {
						text: "Archive Email",
						disabled: parentDisabled || emailArchiveAccess.disabled,
						disabledHoverText: parentDisabled
							? parentDisabledText
							: emailArchiveAccess.disabled
								? emailArchiveAccess.disabledText
								: "",
						onSelect: () =>
							onArchive([id], matterID, apiBasepath, root),
						iconComponent: (
							<IconArchive
								size={16}
								style={{ verticalAlign: "sub" }}
							/>
						),
					}
			: null,
		emailLifecycleStatusObject.IN_TRASH
			? {
					text: "Restore Email from Trash Bin",
					disabled: parentDisabled,
					disabledHoverText: parentDisabled ? parentDisabledText : "",
					onSelect: () =>
						onRestore([id], matterID, apiBasepath, root),
					iconComponent: (
						<IconTrashOff
							size={16}
							style={{ verticalAlign: "sub" }}
						/>
					),
				}
			: {
					text: "Move Email to Trash Bin",
					disabled:
						!!parentDisabled ||
						!!(
							emailLifecycleStatusObject.IN_ARCHIVE &&
							emailArchiveAccess?.disabled
						),
					disabledHoverText: parentDisabled
						? parentDisabledText
						: emailLifecycleStatusObject.IN_ARCHIVE &&
							  emailArchiveAccess?.disabled
							? emailArchiveAccess.disabledText
							: "",
					onSelect: () => onDelete([id], matterID, apiBasepath, root),
					iconComponent: (
						<IconTrashX
							size={16}
							style={{ verticalAlign: "sub" }}
						/>
					),
				},
	].filter(Boolean);

	return menuItems;
};

export default EmailContextMenu;
